import React from 'react';
import styled from 'styled-components';
import { colors } from '../constants';
import Text from '../components/styled/Text';
import { JOB_STATUS } from '../constants';

const StyledTagStatus = styled(Text)`
  border-radius: 45px;
  padding: 4px 8px;
  text-align: center;
  background-color: ${props => props.color};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const STATUS_COLOR = {
  [JOB_STATUS.DRAFT]: colors.grey80,
  [JOB_STATUS.IN_PROGRESS]: colors.green,
  [JOB_STATUS.IN_REVIEW]: colors.grey40,
  [JOB_STATUS.READY]: colors.red,
  [JOB_STATUS.PUBLISHED]: colors.green50,
  [JOB_STATUS.NEW]: colors.yellow,
};

export function TagStatusFormatter({ status }) {
  return (
    <StyledTagStatus variant="body-small" color={STATUS_COLOR[status]}>
      {status}
    </StyledTagStatus>
  );
}
